import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useRef, useEffect } from "react";
import { MenuContext } from "../../../widgets/Menu/context";
import { useMatchBreakpoints } from "../../../contexts";
import StyledMenuItem, { StyledMenuItemContainer } from "./styles";
var MenuItem = function(_param) {
    var children = _param.children, href = _param.href, _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _isDisabled = _param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, scrollLayerRef = _param.scrollLayerRef, statusColor = _param.statusColor, props = _object_without_properties(_param, [
        "children",
        "href",
        "isActive",
        "isDisabled",
        "variant",
        "scrollLayerRef",
        "statusColor"
    ]);
    var isMobile = useMatchBreakpoints().isMobile;
    var menuItemRef = useRef(null);
    var linkComponent = useContext(MenuContext).linkComponent;
    // 检查 href 是否是外部链接 (http:// 或 https:// 开头)
    var isExternalLink = (href === null || href === void 0 ? void 0 : href.startsWith("http://")) || (href === null || href === void 0 ? void 0 : href.startsWith("https://"));
    var itemLinkProps = href ? _object_spread({
        as: linkComponent,
        href: href
    }, isExternalLink && {
        target: "_blank",
        rel: "noopener noreferrer"
    }) : {
        as: "div"
    };
    useEffect(function() {
        if (!isMobile || !isActive || !menuItemRef.current || !(scrollLayerRef === null || scrollLayerRef === void 0 ? void 0 : scrollLayerRef.current)) return;
        var scrollLayer = scrollLayerRef.current;
        var menuNode = menuItemRef.current.parentNode;
        if (!menuNode) return;
        if (scrollLayer.scrollLeft > menuNode.offsetLeft || scrollLayer.scrollLeft + scrollLayer.offsetWidth < menuNode.offsetLeft + menuNode.offsetWidth) {
            scrollLayer.scrollLeft = menuNode.offsetLeft;
        }
    }, [
        isActive,
        isMobile,
        scrollLayerRef
    ]);
    return /*#__PURE__*/ _jsx(StyledMenuItemContainer, {
        $isActive: isActive,
        $variant: variant,
        ref: menuItemRef,
        children: /*#__PURE__*/ _jsx(StyledMenuItem, _object_spread_props(_object_spread(_object_spread_props(_object_spread({}, itemLinkProps), {
            $isActive: isActive,
            $isDisabled: isDisabled,
            $variant: variant,
            $statusColor: statusColor
        }), props), {
            children: children
        }))
    });
};
export default MenuItem;
